module.exports = __webpack_public_path__ + "static/media/logo.4d6e9afa.svg";